import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as BookingService from '_services/booking-service';

const initialState = {
    additionalPassenger: {
        title: "",
        firstName: "",
        secondName: "",
        assistance: "",
        carrierCode: "",
        flightNumber: "",
        referenceNumber: "",
        flightDepartureDate: "",
        dueTime: "",
        prmBio:"",
        originAssistance:false,
        destinationAssistance:false,
        make:"",
        model:"",
        weight:"",
        battery:"",
        width:"",
        height:"",
        equipment:false,
    },
    postedBooking: null,
    status: 'idle',
    error: null
};

// post a booking
export const postBooking = createAsyncThunk('additionalPassenger/postBooking', async (booking) => {
    return BookingService.postBooking(booking);
});

const additionalPassengerSlice = createSlice({
    name: 'additionalPassenger',
    initialState,
    reducers: {
        reset: (state) => initialState,
        setAdditionalPassenger: (state, action) => {
            return {
              ...state,
              additionalPassenger: action.payload,
            }
        },
        setPassengerFlightInformation: (state, action) => {
            return {
              ...state,
              flightNumber: action.payload.flightNumber,
              carrierCode: action.payload.carrierCode,
              flightDepartureDate: action.payload.flightDepartureDate,
              originAssistance: action.payload.originAssistance,
              destinationAssistance: action.payload.destinationAssistance,
            }
        }
    },
    extraReducers: {
        [postBooking.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [postBooking.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              postedBooking: action.payload,
            }
        },
        [postBooking.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        },
    }
});

export const { reset, setAdditionalPassenger, setPassengerFlightInformation } = additionalPassengerSlice.actions;
export const selectAdditionalPassenger = state => state.additionalPassenger.additionalPassenger;
export const selectAdditionalPassengerBooking = state => state.additionalPassenger.postedBooking;
export const selectAdditionalPassengerStatus = state => state.additionalPassenger.status;
export default additionalPassengerSlice.reducer;
